module.exports = __webpack_public_path__ + "assets/img/stepOne.00381b14.png";